/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";

const AddNewsItemButton = (props) => {
    
    const setOpen = props.setOpen;

    const openDialog = () => {
        setOpen(true);
    };

    return (
        <div 
            className="news-highlights-add-news-item-button"
            onClick={openDialog}
        >
            <div className="news-highlights-add-news-item-button-text">Select a news item</div>
        </div>
    );
};

export { AddNewsItemButton };

